import { z } from "zod";

import { baseTimeDataPointSchema } from "./carton-production";

const trimTimeDataSchema = baseTimeDataPointSchema.extend({
	trimArea: z.number(),
	totalZFoldArea: z.number(),
	percentage: z.number(),
});

const trimByBaleWidthSchema = z.object({
	corrugateAlias: z.string(),
	corrugateFlute: z.string(),
	corrugateBrand: z.string(),
	zFoldWidth: z.number(),
	trimArea: z.number(),
	totalZFoldArea: z.number(),
	baleWidth: z.number().optional(),
	trimPercentage: z.number().optional(),
	percentage: z.number().optional(),
});

const trimByMachineSchema = z.object({
	machineName: z.string(),
	machineId: z.string().optional(),
	trimArea: z.number(),
	totalZFoldArea: z.number(),
	trimPercentage: z.number().optional(),
	percentage: z.number().optional(),
});

const trimOverTimeSchema = z.object({
	machineName: z.string(),
	machineId: z.string().optional(),
	data: z.array(trimTimeDataSchema),
});

export const trimResponseSchema = z.object({
	totalTrimArea: z.number(),
	totalZFoldArea: z.number(),
	totalPercentage: z.number(),
	byBaleWidth: z.array(trimByBaleWidthSchema),
	byMachine: z.array(trimByMachineSchema),
	overTime: z.array(trimOverTimeSchema),
	isScheduleApplied: z.boolean(),
});

export type TrimTimeData = z.infer<typeof trimTimeDataSchema>;
export type TrimByBaleWidth = z.infer<typeof trimByBaleWidthSchema>;
export type TrimByMachine = z.infer<typeof trimByMachineSchema>;
export type TrimApiResponse = z.infer<typeof trimResponseSchema>;

export const DEFAULT_TRIM_API_RESPONSE: TrimApiResponse = {
	totalTrimArea: 0,
	totalZFoldArea: 0,
	totalPercentage: 0,
	byMachine: [],
	byBaleWidth: [],
	overTime: [],
	isScheduleApplied: false,
};
